/**
 * @class loavies.models.app
 * @memberOf loavies.models
 */
export class AppListItemModel {
  /**
   * @param {string} title
   * @param {string|number} value
   * @param {boolean} [valueIsBold]
   * @param {boolean} [valueHasGradient]
   * @param {Object} [emits]
   * @param {string} [icon]
   */
  constructor({
    title,
    value,
    valueIsBold,
    valueHasGradient,
    emits,
    icon,
  }) {
    /** @type {string} */
    this.title = title

    /** @type {string|number} */
    this.value = value

    /** @type {boolean} */
    this.valueIsBold = valueIsBold ?? false

    /** @type {boolean} */
    this.valueHasGradient = valueHasGradient ?? false

    /** @type {Object} */
    this.emits = emits ?? {}

    /** @type {null|string} */
    this.icon = icon ?? null
  }
}
